import { useNavigate } from "react-router-dom";
import { GlassCard, GlassCardContent } from "@/components/ui/glass-card";
import { Button } from "@/components/ui/button";
import { ShieldCheck, ArrowRight } from "lucide-react";

const SEVERITIES = [
  { label: "Critical", range: "CVSS 9.0–10.0", color: "bg-destructive", bars: 4, default: "Enforce immediately" },
  { label: "High", range: "CVSS 7.0–8.9", color: "bg-[hsl(30_80%_55%)]", bars: 3, default: "Enforce within 7 days" },
  { label: "Medium", range: "CVSS 4.0–6.9", color: "bg-[hsl(45_90%_55%)]", bars: 2, default: "Notify only" },
  { label: "Low", range: "CVSS 0.1–3.9", color: "bg-muted-foreground", bars: 1, default: "No action" },
];

export function RemediationPolicyTab() {
  const navigate = useNavigate();

  return (
    <div className="space-y-4">
      <div className="flex items-start justify-between gap-4 rounded-xl border border-border/50 bg-muted/30 p-4">
        <div className="flex items-start gap-3">
          <ShieldCheck className="h-5 w-5 text-primary mt-0.5 shrink-0" />
          <div>
            <p className="text-sm font-medium">Tie severity to action timelines</p>
            <p className="text-xs text-muted-foreground mt-0.5">
              Configure how quickly each severity level is enforced across your fleet via Patch Policies.
            </p>
          </div>
        </div>
        <Button size="sm" onClick={() => navigate("/configurations?type=patch-policy")}>
          Open Patch Policies <ArrowRight className="h-3.5 w-3.5 ml-1" />
        </Button>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
        {SEVERITIES.map((s) => (
          <GlassCard key={s.label} variant="default">
            <GlassCardContent className="pt-5">
              <div className="flex items-center gap-2">
                <div className="flex gap-0.5">
                  {Array.from({ length: 4 }).map((_, i) => (
                    <div
                      key={i}
                      className={`w-1.5 h-6 rounded-sm ${i < s.bars ? s.color : "bg-muted"}`}
                    />
                  ))}
                </div>
                <div>
                  <p className="text-sm font-semibold">{s.label}</p>
                  <p className="text-[10px] text-muted-foreground">{s.range}</p>
                </div>
              </div>
              <p className="text-xs text-muted-foreground mt-3">
                Default: <span className="text-foreground font-medium">{s.default}</span>
              </p>
            </GlassCardContent>
          </GlassCard>
        ))}
      </div>
    </div>
  );
}
